module.exports = __webpack_public_path__ + "static/media/call_sharing_screen_end.4511acd2.svg";